import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Select,
  Upload,
  Card,
  Row,
  Col,
  Table,
  Divider,
  Checkbox,
  message,
} from "antd";
import {
  DeleteOutlined,
  LinkOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import PageTitle from "../PageTitle";
import { useParams } from "react-router-dom";
import useTenantNavigate from "../../hooks/useTenantNavigate";
import { useAxiosPost } from "../../hooks/useAxios";
import { toast } from "react-toastify";
import { getNoticeDetails, postData } from "../../api/apiService";
import axios from "axios";
import FileUploadModal from "../FileUploadModal";
import moment from "moment";
import { FILE_PREFIX, getFileUrl } from "../../utils/constants";
import { getClientDocType } from "../../utils/helpers";
import { DOCUMENTS } from "../../api/endpointMap";
import { getEmbedToken } from "../../api/api";

const { Option } = Select;

const ADDTDSNoticeForm = ({ serviceType }) => {
  const [form] = Form.useForm();
  const { clientId } = useParams();
  const navigate = useTenantNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [selectedUploadType, setSelectedUploadType] = useState(null);
  const [receipt, setreceipt] = useState(null);
  const [jsutificationReport, setJustificationReport] = useState(null);
  const [clientDetails, setClientDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rrrItems, setRRRItems] = useState([]);
  const [attachements, setAttachments] = useState([]);

  const attachmentsColumns = [
    { title: "No.", dataIndex: "key", key: "key" },

    {
      title: "File",
      dataIndex: "file",
      key: "file",
      render: (text, record, index) =>
        record.file ? (
          <div className="flex items-center space-x-2">
            <a href={record.file} target="_blank" rel="noopener noreferrer">
              <Button icon={<LinkOutlined />}>View</Button>
            </a>
            <Button
              icon={<DeleteOutlined />}
              onClick={() => {
                const updatedAttachments = [...attachements];
                updatedAttachments[index].file = null;
                setAttachments(updatedAttachments);
              }}
            />
          </div>
        ) : (
          <Button
            icon={<UploadOutlined />}
            onClick={() => {
              setSelectedUploadType(`attachment-${index}`);
              setIsModalVisible(true);
            }}
          >
            Attach
          </Button>
        ),
    },
  ];

  const RRRColumns = [
    { title: "No.", dataIndex: "key", key: "key" },
    {
      title: "Transaction Type",
      dataIndex: "transaction_type",
      key: "transaction_type",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Transaction Type"
          onChange={(e) =>
            handleEditRRRItemsRow(index, "transaction_type", e.target.value)
          }
        />
      ),
    },
    {
      title: "RRR Number",
      dataIndex: "rrr_number",
      key: "rrr_number",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="RRR Number"
          onChange={(e) =>
            handleEditRRRItemsRow(index, "rrr_number", e.target.value)
          }
        />
      ),
    },
  ];

  const [statusOptions, setStatusOptions] = useState([
    {
      label: "Open",
      value: "Open",
    },
    {
      label: "Close",
      value: "Close",
    },
    {
      label: "OverDue",
      value: "OverDue",
    },
  ]);

  const fetchClientDetails = async () => {
    try {
      // FastAPI port: the legacy Frappe `GET /api/v1/documents/data?
      // doctype=TDS Client&docname=...` endpoint was never ported and
      // returned 404. Use the per-portal client-detail endpoint that
      // already exists (`GET /api/v1/tds/clients/{id}`). This component
      // is wired only on the TDS routes (App.js:445, App.js:1335) so
      // the hard-coded /tds/ path is safe; the `serviceType` prop is
      // still honoured by the rest of the form for label / submit
      // semantics.
      const clientsResponse = await getNoticeDetails(
        `/api/v1/tds/clients/${clientId}`,
      );
      // FastAPI envelope is { message, success, data }. Legacy Frappe
      // returned the row under `message`. Normalise + alias `id` → `name`
      // so the submit handler's `clientDetails.name` reference (line
      // ~218) keeps working without a wider refactor.
      const data = clientsResponse?.data || clientsResponse?.message || {};
      setClientDetails({ ...data, name: data.name || data.id });
    } catch (err) {
      toast.error(err);
    }
  };

  const handleAddRRRItemsRow = () => {
    const newRow = {
      key: rrrItems.length + 1,
      transaction_type: "",
      rrr_number: "",
    };
    setRRRItems([...rrrItems, newRow]);
  };

  const handleEditRRRItemsRow = (index, field, value) => {
    const newData = [...rrrItems];
    newData[index][field] = value;
    console.log("NEWWW", newData);
    setRRRItems(newData);
  };

  const handleAddAttachmentsRow = () => {
    const newRow = { key: attachements.length + 1, file: null };
    setAttachments([...attachements, newRow]);
  };

  const handleEditAttachmentsRow = (index, field, value) => {
    const newData = [...attachements];
    newData[index][field] = value;
    setAttachments(newData);
  };

  const onFinish = async (values) => {
    console.log("Form Values:", values);

    const formErrors = form.getFieldsError();
    console.log("FORM ERRORS", formErrors);
    const hasErrors = formErrors.some((error) => error.errors.length > 0);

    if (hasErrors) {
      message.error("Please fix all validation errors before submitting!");
      return;
    }

    const serviceEndpoint =
      serviceType == "gstin"
        ? "gstin"
        : serviceType == "tds"
        ? "tds"
        : "income-tax";

    const payload = {
      ...values,
      filling_date: values.filling_date
        ? values.filling_date.format("YYYY-MM-DD")
        : null,
      issue_date: values.issue_date
        ? values.issue_date.format("YYYY-MM-DD")
        : null,
      due_date: values.due_date ? values.due_date.format("YYYY-MM-DD") : null,
      date_on_which_tax_deposited: values.date_on_which_tax_deposited
        ? values.date_on_which_tax_deposited.format("YYYY-MM-DD")
        : null,
      // rrr_items: rrrItems.map((item) => ({
      //   rrr_number: item.rrr_number,
      //   transaction_type: item.transaction_type,
      //   key: item.key,
      // })),
      attachments: attachements.map((item) => ({
        file: item.file,
        key: item.key,
      })),
      client: clientDetails.name,
      // `client_name` is needed on the saved Quarter row so the
      // notices list (which reads q.client_name from the BE) shows
      // a non-empty Client Name column. The form doesn't expose a
      // Client Name field — pull it from the loaded clientDetails.
      client_name: clientDetails.client_name,
    };

    try {
      setLoading(true);

      console.log("PAYLOADDD", payload);

      const data = await postData(DOCUMENTS.SAVE, {
        doctype: "Quarter",
        document_data: payload,
      });

      toast.info("Notice Added Successfully", {
        position: "top-right",
        autoClose: 5000,
      });

      setTimeout(() => {
        navigate(`/tds/notices/${clientId}?disabledType=active`);
      }, 500);
    } catch (err) {
      toast.error(err, {
        position: "top-right",
        autoClose: 5000,
      });
      console.log("Error", err);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleUpload = async (file) => {
    try {
      setUploadLoading(true);

      const payload = new FormData();
      payload.append("is_private", "0");
      // payload.append("doctype", "Quarter");
      // payload.append("docname", clientId);
      payload.append("file", file, file.name);

      const token = getEmbedToken() || localStorage.getItem("authToken") || "";
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      // Legacy `/api/v1/documents/upload` returned 404 on FastAPI — the
      // canonical generic upload route is `/api/v1/files/upload` (see
      // app/api/v1/files.py:214). GST form already uses this URL; aligning
      // TDS keeps the upload behaviour identical across portals.
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/api/v1/files/upload",
        payload,
        config
      );

      const fileURL = response?.data?.file_url;

      if (fileURL) {
        if (selectedUploadType == "justificationReport") {
          form.setFieldsValue({ justification_report_file: fileURL });
          setJustificationReport(fileURL);
        } else if (selectedUploadType?.startsWith("attachment")) {
          const index = parseInt(selectedUploadType.split("-")[1], 10);
          const updatedAttachments = [...attachements];
          updatedAttachments[index].file = fileURL;
          setAttachments(updatedAttachments);
        } else {
          form.setFieldsValue({ receipt: fileURL });
          setreceipt(fileURL);
        }
      }

      toast.info("File uploaded successfully", {
        position: "top-right",
        autoClose: 5000,
      });

      handleModalClose();
    } catch (error) {
      toast.error("Error uploading file", {
        position: "top-right",
        autoClose: 5000,
      });
      console.error("Error:", error);
    } finally {
      setUploadLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const lengthLimits = {
    token_number: 15,
    bsr_code_receipt_number: 7,
    challan_serial_number: 5,
    pan_1: 10,
    pan_2: 10,
    pan_3: 10,
  };

  const mandatoryFields = [
    "fy",
    "quarter",
    "form_type",
    // "token_number",
    // "bsr_code_receipt_number",
    // "challan_serial_number",
    // "date_on_which_tax_deposited",
    // "challan_amount",
  ];

  const getValidationRules = (fieldName) => {
    const rules = [];

    // Required field validation
    if (mandatoryFields.includes(fieldName)) {
      rules.push({
        required: true,
        message: `${fieldName} is required!`,
      });
    }

    // Length validation
    if (lengthLimits[fieldName]) {
      rules.push({
        len: lengthLimits[fieldName],
        message: `Must be exactly ${lengthLimits[fieldName]} characters!`,
      });
    }

    // PAN format validation
    if (fieldName.includes("pan_")) {
      rules.push({
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Invalid PAN format! (e.g., ABCDE1234F)",
      });
    }

    return rules;
  };

  const EnhancedInput = ({ fieldName, ...props }) => {
    const maxLength = lengthLimits[fieldName];
    const currentValue = form.getFieldValue(fieldName) || "";

    return (
      <div>
        <Input
          {...props}
          maxLength={maxLength}
          onChange={(e) => {
            // Additional client-side length check
            if (maxLength && e.target.value.length > maxLength) {
              return;
            }
            // Call original onChange if provided
            if (props.onChange) {
              props.onChange(e);
            }
          }}
        />
        {maxLength && (
          <div className="text-xs text-gray-500 mt-1">
            {currentValue.length}/{maxLength}
          </div>
        )}
      </div>
    );
  };

  const getFieldLabel = (label, fieldName) => (
    <span>
      {label}
      {mandatoryFields.includes(fieldName) && (
        <span className="text-red-500 ml-1">*</span>
      )}
    </span>
  );

  const [isFormValid, setIsFormValid] = useState(false);

  const checkFormValidity = () => {
    const values = form.getFieldsValue();
    const errors = form.getFieldsError();

    const allMandatoryFieldsFilled = mandatoryFields.every(
      (field) => values[field] && values[field].toString().trim() !== ""
    );

    const hasErrors = errors.some((error) => error.errors.length > 0);

    setIsFormValid(allMandatoryFieldsFilled && !hasErrors);
  };

  // useEffect(() => {
  //   // const unsubscribe = form.getFieldsError();
  //   checkFormValidity();
  // }, [form]);

  useEffect(() => {
    fetchClientDetails();
  }, []);

  useEffect(() => {
    if (clientDetails) {
      form.setFieldValue("client", clientDetails?.client_name);
    }
  }, [clientDetails]);

  return (
    <div>
      <PageTitle title="New TDS NOTICE" />
      <div className="min-h-screen flex flex-col items-center justify-center bg-blue-100 p-4">
        <div className="w-full max-w-5xl bg-white shadow-lg rounded-2xl p-6">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="w-full"
          >
            <Card
              title="Notice Details"
              bordered={false}
              style={{ border: "4px solid #f5f5f5", marginBottom: "16px" }}
              headStyle={{ borderBottom: "3px solid #f5f5f5" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item label="Client" name="client">
                    <Input readOnly />
                  </Form.Item>
                </Col>

                <Divider style={{ margin: "10px" }} />

                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("Financial Year", "fy")}
                    name="fy"
                    rules={getValidationRules("fy")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Net Payable (Rounded-Off)"
                    name="net_payable"
                  >
                    <InputNumber
                      min={0}
                      size="large"
                      style={{ width: "100%" }}
                      controls={false}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("Quarter", "quarter")}
                    name="quarter"
                    rules={getValidationRules("quarter")}
                  >
                    <Select
                      placeholder="Select Quarter"
                      style={{ height: "40px" }}
                      options={[
                        { value: "Q1", label: "Q1" },
                        { value: "Q2", label: "Q2" },
                        { value: "Q3", label: "Q3" },
                        { value: "Q4", label: "Q4" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12}>
                  <Form.Item label="Issue Date" name="issue_date">
                    <DatePicker
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("Form Type", "form_type")}
                    name="form_type"
                    rules={getValidationRules("form_type")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item label="Due Date" name="due_date" rules={[{ required: true, message: "Please select a due date" }]}>
                    <DatePicker
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={12}>
                  <Form.Item label="Manual demand" name="manual_demand">
                    <Input />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={12}>
                  <Form.Item label="Notice Status" name="notice_status">
                    <Select
                      defaultValue={"Open"}
                      style={{ height: "40px" }}
                      placeholder="Select"
                      allowClear
                    >
                      {statusOptions.map((status) => (
                        <Option key={status.label} value={status.value}>
                          {status?.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item label="Processed Demand" name="processed_demand">
                    <InputNumber
                      min={0}
                      size="large"
                      style={{ width: "100%" }}
                      controls={false}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}></Col>

                <Col xs={24} sm={12}>
                  <Form.Item label="Notice letter" name="receipt">
                    {receipt ? (
                      <div className="flex items-center space-x-2">
                        <a
                          href={getFileUrl(receipt)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button icon={<LinkOutlined />}>
                            {" "}
                            {/* Display basename only — strip the S3
                                signed-URL query string (?X-Amz-...) so
                                the button doesn't overflow the cell. The
                                full URL stays on the wrapping <a href>. */}
                            <span>{receipt?.split("/")?.pop()?.split("?")[0]}</span>
                          </Button>
                        </a>

                        <Button
                          icon={<DeleteOutlined />}
                          onClick={() => {
                            setreceipt(null);
                            form.setFieldsValue({ receipt: "" });
                          }}
                        />
                      </div>
                    ) : (
                      <Button
                        onClick={() => {
                          setSelectedUploadType("receipt");
                          setIsModalVisible(true);
                        }}
                        icon={<UploadOutlined />}
                      >
                        Attach
                      </Button>
                    )}
                  </Form.Item>
                </Col>

                {/* <Divider style={{ margin: "10px" }} />

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Acknowledgement Number"
                    name="acknowledgement_number"
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item label="Filling Date" name="filling_date">
                    <DatePicker
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col> */}
              </Row>
            </Card>

            {/* <Card
              title="RRR Items"
              bordered={false}
              headStyle={{ borderBottom: "3px solid #f5f5f5" }}
              style={{ border: "4px solid #f5f5f5", marginBottom: "16px" }}
            >
              <Table
                columns={RRRColumns}
                dataSource={rrrItems}
                pagination={false}
                bordered
              />
              <Button
                onClick={handleAddRRRItemsRow}
                icon={<PlusOutlined />}
                className="mt-4"
              >
                Add Row
              </Button>
            </Card> */}

            <Card
              title={"For Justification Report"}
              bordered={false}
              style={{ border: "4px solid #f5f5f5", marginBottom: "16px" }}
              headStyle={{ borderBottom: "3px solid #f5f5f5" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel(
                      "Token Number / Provisional Receipt Number (PRN)",
                      "token_number"
                    )}
                    name="token_number"
                    rules={getValidationRules("token_number")}
                  >
                    <EnhancedInput fieldName="token_number" />
                  </Form.Item>

                  {/* <Form.Item name="cin_check_1" valuePropName="checked">
                    <Checkbox className="text-xs">
                      Please select if you have ONLY NIL Challan(s)(Challan(s)
                      with zero challan amount) in the statement.
                    </Checkbox>
                  </Form.Item> */}

                  <Form.Item name="cin_check_2">
                    <Checkbox className="text-xs" valuePropName="checked">
                      Please select if the payment was done by book adjustment
                      (for Government Deductors)
                    </Checkbox>
                  </Form.Item>

                  <Form.Item
                    label={getFieldLabel(
                      "BSR Code / Receipt Number",
                      "bsr_code_receipt_number"
                    )}
                    name="bsr_code_receipt_number"
                    rules={getValidationRules("bsr_code_receipt_number")}
                  >
                    <EnhancedInput fieldName="bsr_code_receipt_number" />
                  </Form.Item>

                  <Form.Item
                    label="Date on which Tax Deposited"
                    name="date_on_which_tax_deposited"
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                  <Form.Item
                    label={getFieldLabel(
                      "Challan Serial Number / DDO",
                      "challan_serial_number"
                    )}
                    name="challan_serial_number"
                    rules={getValidationRules("challan_serial_number")}
                  >
                    <EnhancedInput fieldName="challan_serial_number" />
                  </Form.Item>

                  <Form.Item
                    label={getFieldLabel(
                      "Challan Amount / Transfer Voucher / DDO",
                      "challan_amount"
                    )}
                    name="challan_amount"
                    rules={getValidationRules("challan_amount")}
                  >
                    <EnhancedInput fieldName="challan_amount" />
                  </Form.Item>

                  <Form.Item label="CD Record Number" name="cd_record_number">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              title={
                "Please enter three distinct PAN-Amount combinations corresponding to the challan details mentioned above."
              }
              bordered={false}
              style={{ border: "4px solid #f5f5f5", marginBottom: "16px" }}
              headStyle={{ borderBottom: "3px solid #f5f5f5" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("PAN 1", "pan_1")}
                    name="pan_1"
                    rules={getValidationRules("pan_1")}
                  >
                    <EnhancedInput
                      fieldName="pan_1"
                      placeholder="e.g., ABCDE1234F"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("AMT 1", "amt_1")}
                    name="amt_1"
                    rules={getValidationRules("amt_1")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("PAN 2", "pan_2")}
                    name="pan_2"
                    rules={getValidationRules("pan_2")}
                  >
                    <EnhancedInput
                      fieldName="pan_2"
                      placeholder="e.g., ABCDE1234F"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("AMT 2", "amt_2")}
                    name="amt_2"
                    rules={getValidationRules("amt_2")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("PAN 3", "pan_3")}
                    name="pan_3"
                    rules={getValidationRules("pan_3")}
                  >
                    <EnhancedInput
                      fieldName="pan_3"
                      placeholder="e.g., ABCDE1234F"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={getFieldLabel("AMT 3", "amt_3")}
                    name="amt_3"
                    rules={getValidationRules("amt_3")}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Divider style={{ margin: "0px" }} />

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Last Justification Message "
                    name="last_justification_message"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Last Justification Request Time"
                    name="last_justification_request_time"
                  >
                    <input
                      type="datetime-local"
                      className="w-full p-3 border rounded-md"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="Authcode Value" name="authcode_value">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Request Number" name="request_number">
                    <Input />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Justification Report File"
                    name="justification_report_file"
                  >
                    {jsutificationReport ? (
                      <div className="flex items-center space-x-2">
                        <a
                          href={getFileUrl(jsutificationReport)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button icon={<LinkOutlined />}>
                            {" "}
                            {/* Same basename-only display as the Notice
                                letter row above — strip S3 query string. */}
                            <span>
                              {jsutificationReport
                                ?.split("/")
                                ?.pop()
                                ?.split("?")[0]}
                            </span>
                          </Button>
                        </a>

                        <Button
                          icon={<DeleteOutlined />}
                          onClick={() => {
                            setJustificationReport(null);
                            form.setFieldsValue({
                              justification_report_file: "",
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <Button
                        onClick={() => {
                          setSelectedUploadType("justificationReport");
                          setIsModalVisible(true);
                        }}
                        icon={<UploadOutlined />}
                      >
                        Attach
                      </Button>
                    )}
                    <p className="mt-2">(ZIP FILE)</p>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              title="Justification Report Attachments"
              bordered={false}
              headStyle={{ borderBottom: "3px solid #f5f5f5" }}
              style={{ border: "4px solid #f5f5f5", marginBottom: "16px" }}
            >
              <Table
                columns={attachmentsColumns}
                dataSource={attachements}
                pagination={false}
                bordered
              />
              <Button
                onClick={handleAddAttachmentsRow}
                icon={<PlusOutlined />}
                className="mt-4"
              >
                Add Row
              </Button>
            </Card>

            <div className="flex justify-end mt-4">
              <Button loading={loading} type="primary" htmlType="submit">
                {loading ? "Adding.." : " Add Notice"}
              </Button>
            </div>
          </Form>
        </div>
      </div>

      <FileUploadModal
        visible={isModalVisible}
        onClose={handleModalClose}
        onUpload={handleUpload}
        disabled={uploadLoading}
      />
    </div>
  );
};

export default ADDTDSNoticeForm;
